import RecordHistoryModel from 'models/RecordHistoryModel';

export default class AddonAnswerHistoryModel extends RecordHistoryModel {}
